import type { FieldData } from '@bringg/types';

import { ControlFormatType, FieldType } from 'bringg-web/features/actions-data/field-data/field-data.consts';

export const hasRegexValidation = (fieldData: FieldData) => {
	return fieldData.control === FieldType.Field && fieldData.type === ControlFormatType.Text;
};
